export default {
  title: "Calculation Templates",
  filter: {
    name: "Template Name",
    namePlaceholder: "Please enter template name",
    type: "Template Type",
    typePlaceholder: "Please select template type",
  },
  table: {
    name: "Template Name",
    type: "Type",
    createdAt: "Created At",
    actions: "Actions",
    single: "Single Calculation",
    batch: "Batch Calculation",
  },
  action: {
    edit: "Edit Name",
    use: "Use",
  },
  modal: {
    editTitle: "Edit Template Name",
    nameLabel: "Template Name",
    namePlaceholder: "Please enter template name",
    nameRequired: "Please enter template name",
  },
  deleteConfirm: {
    title: "Delete Template",
    content: "Are you sure you want to delete this template?",
  },
  message: {
    fetchFailed: "Failed to fetch template list",
    updateSuccess: "Template name updated successfully",
    updateFailed: "Update failed",
    deleteSuccess: "Template deleted successfully",
  },
};
